import type { LucideIcon } from 'lucide-react';

interface StatCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  isLoading?: boolean;
}

export function StatCard({
  label,
  value,
  subtitle,
  icon: Icon,
  variant = 'default',
  isLoading,
}: StatCardProps) {
  const variantStyles = {
    default: '',
    success: 'border-success/30',
    warning: 'border-amber-500/30',
    error: 'border-ember/30',
    info: 'border-rune/30',
  };

  if (isLoading) {
    return (
      <div className={`bg-night border border-stone/30 rounded-xl p-4 ${variantStyles[variant]}`}>
        <div className="animate-pulse space-y-2">
          <div className="h-4 bg-stone/50 rounded w-1/2"></div>
          <div className="h-8 bg-stone/50 rounded w-3/4"></div>
          {subtitle && <div className="h-3 bg-stone/50 rounded w-1/3"></div>}
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-night border border-stone/30 rounded-xl p-4 ${variantStyles[variant]}`}>
      <div className="flex items-center justify-between mb-1">
        <div className="text-mist text-sm">{label}</div>
        {Icon && <Icon size={16} className="text-mist/50" />}
      </div>
      <div className="text-parchment text-2xl font-display">{value}</div>
      {subtitle && <div className="text-mist/50 text-xs mt-1">{subtitle}</div>}
    </div>
  );
}
